import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

const ModalFooter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 20px 18px 32px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);

    ${media.mdmin`
        padding: 20px;
        box-shadow: none;
        border-top: 1px solid ${COLORS.mlbGrey6};
    `}
`;

export default ModalFooter;
